import type { SubscriptionListResponse } from '@/common/api/client/types.gen'

const DAY_LABELS: Record<number, string> = {
    1: 'день',
    2: 'дня',
    3: 'дня',
    4: 'дня',
}

const MONTH_LABELS: Record<number, string> = {
    1: 'месяц',
    2: 'месяца',
    3: 'месяца',
    4: 'месяца',
}

const getPeriodLabel = (count: number, labels: Record<number, string>, defaultLabel: string) => {
    const mod10 = count % 10
    const mod100 = count % 100
    if (mod100 >= 11 && mod100 <= 14) return defaultLabel
    if (mod10 === 1) return labels[1]
    if (mod10 >= 2 && mod10 <= 4) return labels[mod10] ?? defaultLabel
    return defaultLabel
}

export const formatSubscriptionPeriod = (period: SubscriptionListResponse['period'], numPeriods: number) => {
    if (period === 'Day') {
        const label = getPeriodLabel(numPeriods, DAY_LABELS, 'дней')
        return `${numPeriods} ${label}`
    }
    const label = getPeriodLabel(numPeriods, MONTH_LABELS, 'месяцев')
    return `${numPeriods} ${label}`
}

export const formatSubscriptionChargeInterval = (period: SubscriptionListResponse['period'], numPeriods: number) => {
    if (numPeriods === 1) {
        return period === 'Day' ? 'Списание каждый день' : 'Списание каждый месяц'
    }

    return `Списание каждые ${formatSubscriptionPeriod(period, numPeriods)}`
}
